module.exports = __webpack_public_path__ + "img/section4Logo7.4dc95cf1.svg";